
import {
    IndexTable,
    InlineStack,
    Box,
    Button,
    Select,
    Banner,
  } from "@shopify/polaris";
  import React, { useState } from "react";
  import BadgeTag from "../common/BadgeTag";
  import { useMemo } from "react";
  import _ from "lodash";
  import BulkPaymentAdditional from "../modal/BulkPaymentAdditional";
  import WalletForOrderModal from "../modal/WalletForOrderModal";
  import PayForOrderModal from "../modal/PayForOrderModal";
  import InitNotPageContent from "../common/InitNotPageContent";
  import InitPageContent from "../common/InitPageContent";
  import CommonTableSkeletonItem from "../common/CommonTableSkeletonItem";
  import SymbolTake from "../../../../components/SymbolTake";
import { reqGetOrderNewAdditionalPayment, reqGetOrderNewPaymentProcess } from "../../../../api";
  const OrderTable = ({
    selected,
    listData,
    setListData,
    selectableOrders,
    selectedResources,
    allResourcesSelected,
    handleSelectionChange,
    setSearchLoading,
    requestParams,
    getPageData,
    loading,
    toastFun
  }) => {
      // 礼品包装
        // 总条数
        const pageMsg = () => {
          let total = listData.count ? listData.count : 0;
          const { page, size } = requestParams;
          const startNum = total > 0 ? (page - 1) * size + 1 : 0;
          const endNum = page * size > total ? total : page * size;
          let text = (
            <div>
              Showing {startNum} - {endNum} of {total} results
              <div  className="per_page_footer">
                ,{" "}
                at most{" "}
                <div className="per_page_select">
                  {" "}
                  <Select
                    options={[
                      { label: 10, value: 10 },
                      { label: 20, value: 20 },
                      { label: 30, value: 30 },
                      { label: 50, value: 50 },
                    ]}
                    onChange={(value) => {
                      const calculatedTotalPages = Math.ceil(total / Number(value));
                      if (page > calculatedTotalPages) {
                        // 如果当前页码超出范围，重置为第一页
                       getPageData({ size: Number(value),page:1 });
                     }else {
                       getPageData({ size: Number(value) });
                     }
                      setSearchLoading(true);
                    }}
                    value={requestParams.size}
                  />
                </div>
                per page
              </div>
            </div>
          );
          return text;
      
          // eslint-disable-next-line react-hooks/exhaustive-deps
        };
      
        // 是否存在上一页
        const hasPrevious = useMemo(() => {
          const { page, size } = requestParams;
          let total = listData.count ? listData.count : 0;
         
          const maxPageNum = _.ceil(total / size);
          if (page > 1 && page <= maxPageNum) {
            return loading ? false : true;
          } else if (page === 1) {
            return false;
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [listData, requestParams, loading]);
      
        // 是否存在下一页
        const hasNext = useMemo(() => {
          const { page, size } = requestParams;
          let total = listData.count ? listData.count : 0;
          const maxPageNum = _.ceil(total / size);
          if (_.inRange(page, 1, maxPageNum)) {
            return loading ? false : true;
          } else if (page === maxPageNum) {
            return false;
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [listData, requestParams, loading]);
      
        // 上一页
        const handlePrev = () => {
            getPageData({ page: Number(requestParams.page) - 1 });
            setSearchLoading(true);
          handleSelectionChange("page", false, 0);
          if (document) {
            if (document?.documentElement || document?.body) {
              document.documentElement.scrollTop = document.body.scrollTop = 0;
            }
          }
        };
      
        // 下一页
        const handleNext = () => {
            getPageData({ page: Number(requestParams.page) + 1 });
            setSearchLoading(true);
          handleSelectionChange("page", false, 0);
          if (document) {
            if (document?.documentElement || document?.body) {
              document.documentElement.scrollTop = document.body.scrollTop = 0;
            }
          }
        };

         //订单支付操作需要数据
  const [paymentData, setPaymentData] = useState({
    toPayOrderId: "",
    toPayOrderName: [],
    toPayOrderType: 0, // 订单类型：1 shopify 2 礼品包装 3 产品批发
    toPayActive: false,
    createPayPalOrderId: 0,
    isBatchToPay: false, //批量付款
    batchPayOrderIds: [],
    handleWalletActiveLoading: false, //钱包确定支付按钮
    toCheckoutLoading: false, //钱包支付加载状态
    payLogId: 0, // 执行支付记录ID
    operationNumber: 0,
    currentExecutionsNumber: 0,
    isShowBulkPaymentModal: false, //批量支付弹窗
    totalPrice: 0, //价格钱包支付计算产品总价
    toPayCouponMoney:0,
    totalPriceWallet:0
  });

  const handleBulkPayment = (id)=>{
    // 创建 Set 用于快速查找
    const idSet = new Set(id);
    // 过滤出 id 在 Set 中的对象
    const result = listData?.list.filter(item => idSet.has(item.id)).map(item=>item.id);
    let data = listData?.list;
    let ids = [];
    let name = [];

    //金额
    var totalPrice = 0;
    for (let i = 0; i < data.length; i++) {
      if (result.includes(data[i].id)) {
          ids.push(data[i].id);
          name.push(data[i].dsm_order_number);
          totalPrice +=
            Number(data[i].amount);
        }
    }
    if (ids.length > 0) {
      setPaymentData((prevValue) => ({
        ...prevValue,
        isBatchToPay: true,
        totalPrice,
        toPayOrderName:name,
        isShowBulkPaymentModal:true,
        batchPayOrderIds: ids,
      }));
     
    } else {
      toastFun("No payable orders");
    }
    
  }
// 钱包支付
const handleWalletActive = async () => {
     
      //判断钱包的钱是否够用
      if (
        listData?.wallet_money <
        paymentData.totalPriceWallet - paymentData.toPayCouponMoney
      ) {
        toastFun("Insufficient balance");
      } else {
        setPaymentData((prevValue) => ({
          ...prevValue,
          handleWalletActiveLoading: true,
        }));
       
        let ids = paymentData.batchPayOrderIds;
  
        let params = {
          ids,
          type: 'wallet',
        };
  
        const response = await reqGetOrderNewAdditionalPayment(params);
        setPaymentData((prevValue) => ({
          ...prevValue,
          toWalletActive: false,
        }));
  
        if (response.code === "200") {
          setPaymentData((prevValue) => ({
            ...prevValue,
            handleWalletActiveLoading: false,
          }));
          toastFun('Payment processing');
          getPageData();
          // 启动定时器查询支付状态
          if (response.data) {
            setPaymentData((prevValue) => ({
              ...prevValue,
              payLogId: response.data.pay_id,
            }));
            var importTimer = setInterval(() => {
              GetPaymentProcess(response.data.pay_id).then(function (response) {
                if (response === 200) {
                  clearInterval(importTimer);
                }
              });
            }, 3000);
          }
        } else {
          toastFun(response.msg);
          setPaymentData((prevValue) => ({
            ...prevValue,
            handleWalletActiveLoading: false,
          }));
        }
        // 创建PayPal订单有误，关闭弹窗
      }
    };

     // 查询支付的状态
      const GetPaymentProcess = async (id) => {
        const params = { id };
        const response = await reqGetOrderNewPaymentProcess(params);
        if (response.code === "200") {
          let getData = response.data;
          setPaymentData((prevValue) => ({
            ...prevValue,
            operationNumber: getData.job === 0 ? getData.total : 0,
            currentExecutionsNumber: getData.job === 0 ? getData.success : 0,
          }));
    
          if (getData.job === 1) {
            // 结束
            setTimeout(() => {
              // 刷新列表
              getPageData()
            }, 1000);
    
            return 200;
          }
          return 201;
        } else {
          setPaymentData((prevValue) => ({
            ...prevValue,
            payLogId: 0,
            operationNumber: 0,
            currentExecutionsNumber: 0,
          }));
    
          return 200;
        }
      };

      // [PayPal] Checkout 弹窗 PaymentType 支付类型 1:PayPal 2:钱包
  const handlePayForOrderModal = (
    ids,
    name,
    type,
    totalPrice
  ) => {
    if (name === 0) {
      setPaymentData((prevValue) => ({
        ...prevValue,
        toPayOrderId: [],
        toPayOrderName: [],
        toPayOrderType: 0,
        batchPayOrderIds: [],
        toPayActive: false,
        isShowBulkPaymentModal:false,
        createPayPalOrderId: 0,
        toWalletActive:false
      }));
      return;
    }
    setPaymentData((prevValue) => ({
      ...prevValue,
      handleWalletActiveLoading: false,
      toCheckoutLoading: false,
    }));

    switch (type) {
      case 1:
        setPaymentData((prevValue) => ({
          ...prevValue,
          toPayOrderId: ids,
          toPayOrderName: name,
          toPayOrderType: type,
          batchPayOrderIds: ids,
          toPayActive: true,
          createPayPalOrderId: 0,
        }));
        handleCheckoutOrder({
          isBatchToPay:paymentData.isBatchToPay,
          batchPayOrderIds: ids,
          toPayOrderId: ids,
        });
        break;
      case 2:
        setPaymentData((prevValue) => ({
          ...prevValue,
          toPayOrderId: ids,
          batchPayOrderIds: ids,
          toPayOrderName: name,
          toPayOrderType: type,
          toWalletActive: true, //打开钱包提示弹窗
          totalPriceWallet: parseFloat(Number(totalPrice).toFixed(2)), //钱包支付订单金额
          createPayPalOrderId: 0,
        }));
        
        break;
      
      default:
        break;
    }
  };
 // checkout order
    const handleCheckoutOrder = async (data) => {
      let ids = data.batchPayOrderIds;
      
      setPaymentData((prevValue) => ({
        ...prevValue,
        toCheckoutLoading: true,
      }));
      let params = {
        ids,
        type:'paypal'
      };
  
      const response = await reqGetOrderNewAdditionalPayment(params);
      setPaymentData((prevValue) => ({
        ...prevValue,
        toCheckoutLoading: false,
      }));
      if (response.code === "200") {
        setPaymentData((prevValue) => ({
          ...prevValue,
          createPayPalOrderId: response.data.id,
        }));
      } else {
        toastFun('Fail to activate');
        handlePayForOrderModal(0, 0, "", 0);
      }
    };


    const resourceName = {
      singular: "order",
      plural: "orders",
    };
    const headingData = [
      { id: "1", title: <span>Order</span> },
      { id: "2", title: <span>Status</span> },
      { id: "3", title: <span>Date</span> },
      { id: "4", title: <span>Item</span> },
      { id: "5", title: <span>Cost total</span> },
      { id: "6", title: <span>Action</span> },
    ];

    const promotedBulkActions = [
      {
        content: 'Bulk payment',
        onAction: () => {
          handleBulkPayment(selectedResources)
        },
      },
    ]
  const statusFun = (value)=>{
    let text = 'Unpaid';
    switch (value) {
      case 1:
        text = 'Unpaid';
        break;
      case 2:
        text = 'Pending';
        break;
      case 3:
        text = 'Paid';
        break;
      case 4:
        text = 'Refunded';
        break;
      default:
        break;
    }
    return text;
  }

    const rowMarkup = listData?.list?.map((item, ind) => {
      // 1. 制作一个手风琴向下展开的盒子
      // 2. 通过控制是否展开的状态，控制是否显示下面的内容
      // 3. 向下展开时有动画效果，收起时也有动画效果
  
      return (
      <IndexTable.Row
            id={item.id}
            key={ind}
            selected={selectedResources.includes(item.id)}
            position={ind}
            disabled={item.payment_status !== 1}
            onClick={()=>{
            }}
          >
            <IndexTable.Cell className="order_cell_01">
              <Box>
                  <InlineStack gap={100} blockAlign="center">
                    <Box className="order_cell_01_title">{item.dsm_order_number}</Box>
                  </InlineStack>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_02">
              <Box><BadgeTag content={statusFun(item.payment_status)} /></Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_03">
              <Box>
              {item.created_at}
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_04">
              <Box>
              <InlineStack gap={200} blockAlign="center" wrap={false}>
                <Box>
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <g filter="url(#filter0_i_4206_22943)">
                  <g clipPath="url(#clip0_4206_22943)">
                  <path d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z" fill="#F7F7F7"/>
                  <path d="M19.5 17.5C19.5 17.0858 19.8358 16.75 20.25 16.75C20.6642 16.75 21 17.0858 21 17.5V17.75H21.75C22.1642 17.75 22.5 18.0858 22.5 18.5C22.5 18.9142 22.1642 19.25 21.75 19.25H19.5C19.2239 19.25 19 19.4739 19 19.75C19 20.0261 19.2239 20.25 19.5 20.25H20.5C21.6046 20.25 22.5 21.1454 22.5 22.25C22.5 23.3546 21.6046 24.25 20.5 24.25V24.5C20.5 24.9142 20.1642 25.25 19.75 25.25C19.3358 25.25 19 24.9142 19 24.5V24.25H18.25C17.8358 24.25 17.5 23.9142 17.5 23.5C17.5 23.0858 17.8358 22.75 18.25 22.75H20.5C20.7761 22.75 21 22.5261 21 22.25C21 21.9739 20.7761 21.75 20.5 21.75H19.5C18.3954 21.75 17.5 20.8546 17.5 19.75C17.5 18.6454 18.3954 17.75 19.5 17.75V17.5Z" fill="#303030"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M27 21C27 24.866 23.866 28 20 28C16.134 28 13 24.866 13 21C13 17.134 16.134 14 20 14C23.866 14 27 17.134 27 21ZM25.5 21C25.5 24.0376 23.0376 26.5 20 26.5C16.9624 26.5 14.5 24.0376 14.5 21C14.5 17.9624 16.9624 15.5 20 15.5C23.0376 15.5 25.5 17.9624 25.5 21Z" fill="#303030"/>
                  <rect x="24" y="13" width="6" height="2" rx="1" fill="#131313"/>
                  <rect x="26" y="17" width="6" height="2" rx="1" transform="rotate(-90 26 17)" fill="#131313"/>
                  </g>
                  </g>
                  <defs>
                  <filter id="filter0_i_4206_22943" x="0" y="0" width="40" height="40" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                  <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                  <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                  <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect1_innerShadow_4206_22943"/>
                  <feOffset/>
                  <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"/>
                  <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4206_22943"/>
                  </filter>
                  <clipPath id="clip0_4206_22943">
                  <path d="M0 8C0 3.58172 3.58172 0 8 0H32C36.4183 0 40 3.58172 40 8V32C40 36.4183 36.4183 40 32 40H8C3.58172 40 0 36.4183 0 32V8Z" fill="white"/>
                  </clipPath>
                  </defs>
                  </svg>
                </Box>
              <Box className="order_cell_04_additional_title">{item.title}</Box>
              </InlineStack>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_05">
              <Box>
              <Box><SymbolTake price={parseFloat(item.amount).toFixed(2)} /></Box>
              </Box>
            </IndexTable.Cell>
            <IndexTable.Cell className="order_cell_06">
              {item.payment_status !== 1 ? '':<Box>
                <InlineStack>
                  <Button onClick={(e)=>{
                    e.stopPropagation();
                    handleBulkPayment([item.id])
                  }}>Payment</Button>
                </InlineStack>
              </Box>}
            </IndexTable.Cell>
          </IndexTable.Row>
      );
    });
  
    // 支付进度显示
        let paymentTips = <div></div>;
        if (paymentData.operationNumber !== 0) {
          paymentTips = (
            <div style={{ marginBottom: "1rem" }}>
              <Banner
                title={
                  paymentData.currentExecutionsNumber +
                  "/" +
                  paymentData.operationNumber +
                  " orders are being paid."
                }
                tone="info"
                // onDismiss={() => {}}
              ></Banner>
            </div>
          );
        }
        // 定义参数有效性检查工具函数
const hasValidParams = (params) => {
  if (!params) return false;

  // 需要验证的非空字符串参数
  const stringParams = [
    "order_number",
    "start_time",
    "end_time",
  ];

  // 需要验证的非空数组参数
  const arrayParams = [
    "payment_status",
  ];

  // 检查字符串参数
  const hasValidString = stringParams.some(
    (key) => params[key] !== undefined && params[key] !== ""
  );

  // 检查数组参数
  const hasValidArray = arrayParams.some((key) => params[key]?.length > 0);

  return hasValidString || hasValidArray;
};
    const emptyStateMarkup =
    Object.values(listData).length > 0 ? (
      <Box>
        {listData?.list?.length === 0 && (
          <Box>
            {hasValidParams(requestParams) ? (
              <InitNotPageContent data={{q:requestParams.order_number}} />
            ) : (
              <InitPageContent
                selected={selected}
                setNoviceModal={()=>{}}
              />
            )}
          </Box>
        )}
      </Box>
    ) : (
      <CommonTableSkeletonItem />
    );
    return (
      <div className="order_table_box product_table_box">
         {paymentTips}
        <IndexTable
          resourceName={resourceName}
          itemCount={selectableOrders?.length
            ? selectableOrders.length
            : listData?.list?.length
            ? listData?.list?.length
            : 0}
          selectedItemsCount={
            allResourcesSelected ? "All" : selectedResources.length
          }
          onSelectionChange={handleSelectionChange}
          headings={headingData}
          promotedBulkActions={promotedBulkActions}
          emptyState={emptyStateMarkup}
          pagination={{
            label: listData?.list?.length > 0 ? pageMsg() : "",
            hasPrevious: hasPrevious,
            onPrevious: () => {
              handlePrev();
            },
            hasNext: hasNext,
            onNext: () => {
              handleNext();
            },
          }}
        >
          {rowMarkup}
        </IndexTable>
        {/* 支付 */}
        <BulkPaymentAdditional 
        paymentData={paymentData}
        walletMoney={listData?.wallet_money}
        handlePayForOrderModal={handlePayForOrderModal}
        setIsShowBulkPaymentModal={() => {
          setPaymentData((prevValue) => ({
            ...prevValue,
            isShowBulkPaymentModal: false,
          }))
        }
        }
        />
        <PayForOrderModal
        paymentData={paymentData}
        handlePayForOrderModal={handlePayForOrderModal}
        getPageData={getPageData} //获取页面数据
        orderPayment={false}
      />
      {/* 钱包支付 */}
      <WalletForOrderModal
        paymentData={paymentData}
        handleWalletActive={handleWalletActive}
        walletMoney={listData?.wallet_money}
        handlePayForOrderModal={handlePayForOrderModal}
      />
      </div>
    );
  };
  
  export default OrderTable;
  